import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // Always show the modal when it's rendered from the server
    this.element.classList.remove('tw-hidden');
  }

  close(event) {
    event.preventDefault();

    // Mark as seen on the server
    this.markAsSeen();

    // Hide the component
    this.element.classList.add('tw-hidden');

    // Remove from DOM after animation
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }

  goToLearningTrail(event) {
    event.preventDefault();

    // Mark as seen on the server
    this.markAsSeen();

    // Navigate to learning trail page
    window.location.href = '/learning_trail/index';
  }

  markAsSeen() {
    // Send AJAX request to mark as seen on the server
    fetch('/learning_trail/mark_onboarding_seen', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Content-Type': 'application/json',
      },
    });
  }
}
